<script setup>
  import { ref, computed, onMounted, nextTick } from 'vue';

  import { useSpotStore } from '@/stores/SpotStore';

  import useContainerConfigurationGlobals from '@/composables/useContainerConfigurationGlobals';
  import useLegacyBridge from "@/composables/useLegacyBridge";

  const { $WIND_GRAPH } = useContainerConfigurationGlobals();

  const model = defineModel();
  const ncWindDataEnabled = defineModel('ncWindDataEnabled');

  const props = defineProps({
    isNCWind: {
      type: Boolean,
      required: true
    }    
  })

  const spotStore = useSpotStore();

  const { currentConditions } = useLegacyBridge();

  const graphContainer = ref(null);

  const multiStationSettings = computed(() => {
    return {
        "width": "100%",
        "spotList": `${spotStore.spotId}`,
        "spotId": spotStore.spotId,
        "favSpotId": spotStore.spotFavoriteId,
        "lat": spotStore.lat,
        "lon": spotStore.lon,        
        "spotName": spotStore.spotName,
        "debug": "false",
        "upgradeAvailable": spotStore.upgradeAvailable,
        "showDataFieldsMenu": $WIND_GRAPH.show_data_fields_menu,
        "showNearbySpots": $WIND_GRAPH.show_nearby_spots,
        "hideData": false,
        "showVirtual": $WIND_GRAPH.show_virtual,
        "stationCapabilities": getStationCapabilities(spotStore.spot.stations),
    };
  });

  const singleStationSettings = computed(() => {
    const station = spotStore.spot.stations[0];

    return {
        "width": "100%",
        "spotId": spotStore.spotId,
        "favSpotId": spotStore.spotFavoriteId,
        "stationId": station.station_id,
        "lat": spotStore.lat,
        "lon": spotStore.lon,
        "spotName": spotStore.spotName,
        "debug": "false",
        "spotStatus": station.status_id,
        "provider": station.provider,
        "spotTypeId": station.Type,
        "upgradeAvailable": spotStore.upgradeAvailable,
        "showDataFieldsMenu": $WIND_GRAPH.show_data_fields_menu,
        "showNearbySpots": $WIND_GRAPH.show_nearby_spots,
        "showVirtual": $WIND_GRAPH.show_virtual,
        "stationCapabilities": getStationCapabilities(spotStore.spot.stations),
        "hideData": true,
        isNCWind: props.isNCWind,
        ncWindDataEnabled: ncWindDataEnabled.value        
    };
  });

  function getStationCapabilities(stations) {
      var stationCapabilites = [];

      stations.forEach(function (station) {
          station.capabilities.forEach(function (capability) {
              if (stationCapabilites.indexOf(capability) === -1) {
                  stationCapabilites.push(capability);
              }
          })
      })

      return stationCapabilites;
  }

  function loadGraph() {
    const settings = spotStore.spot.stations.length > 1 ? multiStationSettings.value : singleStationSettings.value;     

    model.value = currentConditions(graphContainer.value, settings);
  }

  onMounted(() => loadGraph())  
</script>

<template>
  <div
    :id="spotStore.spotId"
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="graphContainer"
  ></div>
</template>